import capitalize from "lodash/capitalize";
import words from "lodash/words";

namespace NonBreaking {
  export const space = "\u00A0";
  export const hyphen = "\u2011";
}

export const preventOrphanWords = (input: string): string => {
  const hyphenedInput = input.replace(/-/g, NonBreaking.hyphen);
  const trimedInput = hyphenedInput.trim();
  const lastSpace = trimedInput.lastIndexOf(" ");
  if (lastSpace === -1) {
    return trimedInput;
  }

  return (
    trimedInput.slice(0, lastSpace) +
    NonBreaking.space +
    trimedInput.slice(lastSpace + 1, trimedInput.length)
  );
};

export const titleCaseWithSpecialCharacters = (input: string): string =>
  words(input, /[^, ]+/g)
    .map((word) => capitalize(word))
    .join(" ");

export const trimToken = (token: string): string => {
  const afterSplit: string[] = token.split("_");
  if (afterSplit.length <= 1) {
    throw Error("trimToken: Invalid token format");
  }

  return afterSplit[1]?.toUpperCase() ?? "";
};
